'use client'

import { Frown, Smile } from 'lucide-react'
import { useState } from 'react'
import { bff_client } from '@/lib/apiClient'

interface FeedbackProps {
  reference: string
}

export default function Feedback({ reference }: FeedbackProps) {
  const [feedbackSelected, setFeedbackSelected] = useState('')

  async function handleFeedback(feedback: 'positive' | 'negative') {
    setFeedbackSelected(feedback)

    const response = await bff_client
      .patch(`knowledge/articles/${reference}/rating`, {
        json: {
          rating_type: feedback,
        },
      })
      .json()
  }

  return (
    <div className="mt-12 flex items-center justify-between rounded-[10px] border border-primary-400 p-6">
      <span className="font-medium text-primary-400">Quão útil foi isso?</span>

      <div className="space-x-2">
        <button
          className="rounded-lg bg-gray-300/25 p-2.5 hover:bg-gray-300 data-[selected=true]:bg-gray-300"
          data-selected={feedbackSelected === 'negative'}
          onClick={() => handleFeedback('negative')}
          type="button"
        >
          <Frown className="size-6 text-primary-600" />
        </button>

        <button
          className="rounded-lg bg-gray-300/25 p-2.5 hover:bg-gray-300 data-[selected=true]:bg-gray-300"
          data-selected={feedbackSelected === 'positive'}
          disabled={feedbackSelected === 'positive'}
          onClick={() => handleFeedback('positive')}
          type="button"
        >
          <Smile className="size-6 text-primary-600" />
        </button>
      </div>
    </div>
  )
}
